/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_AttachmentsInputs */

const en_mk_mx_attachments = /** @type {(inputs: Mk_Mx_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachments an agent may read`)
};

const id_mk_mx_attachments = /** @type {(inputs: Mk_Mx_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lampiran yang boleh dibaca agen`)
};

/**
* | output |
* | --- |
* | "Attachments an agent may read" |
*
* @param {Mk_Mx_AttachmentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_attachments = /** @type {((inputs?: Mk_Mx_AttachmentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_AttachmentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_attachments(inputs)
	return en_mk_mx_attachments(inputs)
});